// Marketplace de templates de fluxo do Escalone.
//
// Os templates vivem em ./templates/<setor>.ts. Este arquivo é só o ponto de
// entrada — mantém os imports existentes (`./defaultTemplates`) funcionando.
//
// Cada template carrega configuração REAL do fluxo (SLA por etapa, layout do
// mini card, transições permitidas, etiquetas e automações). Quem materializa
// isso ao criar o fluxo é App.tsx > handleCreateFromTemplate.

import { DefaultTemplate } from './templates/types';
import { TEMPLATES_FINANCEIRO } from './templates/financeiro';
import { TEMPLATES_COMPRAS } from './templates/compras';
import { TEMPLATES_RH } from './templates/rh';
import { TEMPLATES_TI } from './templates/ti';
import { TEMPLATES_COMERCIAL } from './templates/comercial';
import {
  TEMPLATES_JURIDICO, TEMPLATES_OPERACIONAL,
  TEMPLATES_ATENDIMENTO, TEMPLATES_VIAGENS,
} from './templates/operacoes';
import {
  TEMPLATES_MARKETING, TEMPLATES_LOGISTICA,
  TEMPLATES_QUALIDADE, TEMPLATES_MANUTENCAO,
} from './templates/novosSetores';
import { TEMPLATES_OBRAS } from './templates/obras';
import { TEMPLATES_OBRAS_GESTAO } from './templates/obrasGestao';
import { TEMPLATES_IMOBILIARIO } from './templates/imobiliario';
import { TEMPLATES_PUBLICO } from './templates/publico';
import { TEMPLATES_ARRECADACAO } from './templates/arrecadacao';
import { TEMPLATES_VAREJO } from './templates/varejo';
import { TEMPLATES_SUPPLY_CHAIN } from './templates/supplyChain';

export type {
  DefaultTemplate, TemplateCampo, TemplateEtapa, TemplateCard,
  TemplateEtiqueta, TemplateAutomacao, TemplateEtapaDica, TemplateCampoTipo,
} from './templates/types';
export { TEMPLATE_CATEGORIES } from './templates/types';

// A ordem aqui é a ordem de exibição em "Todos os Templates".
export const DEFAULT_TEMPLATES: DefaultTemplate[] = [
  ...TEMPLATES_FINANCEIRO,
  ...TEMPLATES_COMPRAS,
  ...TEMPLATES_RH,
  ...TEMPLATES_TI,
  ...TEMPLATES_COMERCIAL,
  ...TEMPLATES_MARKETING,
  ...TEMPLATES_JURIDICO,
  ...TEMPLATES_OPERACIONAL,
  ...TEMPLATES_OBRAS,
  ...TEMPLATES_OBRAS_GESTAO,
  ...TEMPLATES_IMOBILIARIO,
  ...TEMPLATES_PUBLICO,
  ...TEMPLATES_ARRECADACAO,
  ...TEMPLATES_VAREJO,
  ...TEMPLATES_LOGISTICA,
  ...TEMPLATES_SUPPLY_CHAIN,
  ...TEMPLATES_MANUTENCAO,
  ...TEMPLATES_QUALIDADE,
  ...TEMPLATES_ATENDIMENTO,
  ...TEMPLATES_VIAGENS,
];
